export default "__VITE_ASSET__da9531b2__"